import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_3 = { class: "p-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, {
    class: "p-fluid",
    visible: _ctx.showAlertMessage,
    modal: true,
    header: "Attenzione",
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          autofocus: "",
          label: "Chiudi",
          icon: "pi pi-times",
          onClick: _ctx.close,
          class: "p-button-info"
        }, null, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_ctx.alertMessage), 1)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}